import { AreaDto } from './area.dto';
import { BaseDto } from './base.dto';
import { BrandDto } from './brand.dto';
import { BusinessHolidayHoursDto } from './business-holiday-hours/businessHolidayHours.dto';
import { BusinessEntityDto } from './businessEntity.dto';
import { BusinessHoursDto } from './businessHours.dto';
import { CharityDto } from './charity.dto';
import { CostCentreDto } from './costCentre.dto';
import { CountryDto } from './country.dto';
import { CurrencyExchangeRateDto } from './currency-exchange-rate/currency-exchange-rate.dto';
import { CurrencyDto } from './currency.dto';
import { DeliverAreaDto } from './deliverArea.dto';
import { DiscountTypeDto } from './discountType.dto';
import { MerchantMenuDto } from './merchant-menu.dto';
import { MerchantBusinessEntityBankDto } from './merchantBusinessEntityBank.dto';
import { MerchantConfigurationDto } from './merchantConfiguration.dto';
import { MerchantGoogleAnalyticsDto } from './merchantGoogleAnalytics.dto';
import { MerchantGroupDto } from './merchantGroup.dto';
import { MerchantPaymentMethodDto } from './merchantPaymentMethod.dto';
import { MerchantSaleRoomDto } from './merchantSaleRoom.dto';
import { MerchantSaleUnitDto } from './merchantSaleUnit.dto';
import { MerchantTypeDto } from './merchantType.dto';
import { OrderNoteOptionDto } from './orderNoteOption.dto';
import { ProductDto } from './product.dto';
import { ReviewSourceTypeDto } from './reviewSourceType.dto';
import { ServiceChargeDto } from './serviceCharge.dto';
import { StockDto } from './stock.dto';
import { SupplierDto } from './supplier.dto';
import { BusinessEntityDepartmentDto } from './businessEntityDepartment.dto';
import { ConfigurationValueDto } from './module-configuration';
import { CuisineDto } from './cuisine.dto';
import { DietDto } from './diet.dto';
import { CityDto } from './city.dto';
import { PaymentVerifiedStatusEnum } from '../enum';

export class MerchantDto extends BaseDto {
  name: string;
  postalCode?: string;
  businessName: string;
  businessNumber?: string;
  address: string;
  cityId?: number;
  city?: CityDto;
  description: string;
  hidden: boolean;
  hiddenOnWhiteLabel: boolean;
  online: boolean;
  costCentre?: CostCentreDto;
  costCentreId: number;
  brand?: BrandDto;
  merchantType?: MerchantTypeDto;
  phoneNumber: string;
  phoneCountryId?: number;
  phoneCountry?: CountryDto;
  imageURL: string;
  latitude: number;
  longitude: number;
  gMTOffset: number;
  locale: string;
  collectionInstructions: string;
  collectionKerbSideInstructions: string;
  notice: string;
  merchantGroupId: number;
  areaId?: number;
  merchantGroup?: MerchantGroupDto;
  area?: AreaDto;
  countryId?: number
  country?: CountryDto;
  reviewSourceTypes?: ReviewSourceTypeDto[];
  businessHours?: BusinessHoursDto[];
  products?: ProductDto[];
  delivery?: boolean;
  collection?: boolean;
  orderAtTable?: boolean;
  collectionKerbSide?: boolean;
  deliveryMinOrder: number;
  deliveryInstructions: string;
  tagline: string;
  deliveryFee: number;
  externalURL?: string;
  registeredOffice?: string;
  vatNumber?: string;
  iban?: string;
  swiftBic?: string;
  sub?=false;
  companyNo?: string;
  accountName?: string;
  sequence?: number;
  merchantPaymentMethods?: MerchantPaymentMethodDto[];
  merchantConfiguration?: MerchantConfigurationDto[];
  merchantBusinessEntity?: BusinessEntityDto;
  merchantBusinessEntityBank?: MerchantBusinessEntityBankDto;
  merchantBusinessEntityBankId?: number;
  currency?: CurrencyDto;
  currencyId?: number;
  stock?: StockDto[];
  suppliers?: SupplierDto[];
  allowPreorder?: boolean;
  preorderPrintBeforeMinutes?: number;
  menus?: MerchantMenuDto[];
  merchantGoogleAnalytics?: MerchantGoogleAnalyticsDto;
  discountTypes?: DiscountTypeDto[];
  serviceCharges?: ServiceChargeDto[];
  isMaster: boolean;
  allowOrderAtTable?: boolean;
  saleRooms?: MerchantSaleRoomDto[];
  saleUnits?: MerchantSaleUnitDto[];
  deliverArea?: DeliverAreaDto[];
  enableJustEatIntegration?: boolean;
  enableDeliverooIntegration?: boolean;
  enableUberEatsIntegration?: boolean;
  paddingDisplayName?: string;
  orderNoteOptions?: OrderNoteOptionDto[];
  contactEmail: string;
  businessHolidayHours?: BusinessHolidayHoursDto[];
  charity?: CharityDto;
  currencyExchangeRates?: CurrencyExchangeRateDto[];
  merchantLink: string
  businessEntityDepartment?: BusinessEntityDepartmentDto;
  active: boolean;
  moduleConfigValue?: ConfigurationValueDto[];
  timeZone?: string;
  merchantBusinessEntityId?: string;
  cuisines?: CuisineDto[];
  diets?: DietDto[];
  distance?: number;
  duration?: number;
  isUltraOrder?: boolean;
  cutoffTime?: string;
  surfboardStoreId?: string;
  paymentVerifiedStatus?: PaymentVerifiedStatusEnum;
}
